import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { List } from '../list/list';
const TransferList = React.memo(({ options, onSelection, enableSearch, virtualize, focusable, size, RTL, }) => {
    return (_jsx(List, { options: options.map(item => ({
            ...item,
            name: item.name,
            value: item.name,
        })), allowMultiSelection: true, maxHeight: 350, noUniqueIds: true, onSelection: onSelection, itemHeight: 40, enableSearch: enableSearch, virtualized: virtualize, size: size, focusable: focusable, RTL: RTL }));
});
TransferList.displayName = 'TransferList';
export { TransferList };
